import React from 'react';

const styles = {
  left: {
    background: '#0c0c0c',
    color: '#f0ede6',
    padding: '2.5rem 2rem',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
    minHeight: '100vh',
  },
  statusDot: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    color: '#888',
    letterSpacing: '0.08em',
    marginBottom: '2.5rem',
    textTransform: 'uppercase',
  },
  dot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    background: '#4ade80',
    flexShrink: 0,
  },
  name: {
    fontFamily: "'DM Serif Display', serif",
    fontSize: '2.6rem',
    lineHeight: 1.05,
    color: '#f0ede6',
    letterSpacing: '-0.02em',
    marginBottom: '0.5rem',
  },
  titleText: {
    fontSize: '0.8rem',
    fontFamily: "'DM Mono', monospace",
    color: '#666',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  divider: {
    width: '32px',
    height: '1px',
    background: '#333',
    margin: '1.5rem 0',
  },
  bio: {
    fontSize: '0.9rem',
    lineHeight: 1.7,
    color: '#999',
    marginBottom: '2rem',
    fontWeight: 300,
  },
  bioStrong: {
    color: '#ccc',
    fontWeight: 500,
  },
  skillsLabel: {
    fontSize: '10px',
    fontFamily: "'DM Mono', monospace",
    color: '#555',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    marginBottom: '0.75rem',
  },
  skills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    marginBottom: '2rem',
  },
  skillTag: {
    fontSize: '11px',
    fontFamily: "'DM Mono', monospace",
    background: '#1a1a1a',
    color: '#888',
    border: '0.5px solid #2a2a2a',
    padding: '4px 10px',
    borderRadius: '3px',
  },
  contactLinks: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginTop: 'auto',
    paddingTop: '2rem',
  },
  contactLink: {
    fontSize: '12px',
    fontFamily: "'DM Mono', monospace",
    color: '#555',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
  },
};

const skillsList = ['Golang', 'React', 'Java', 'Python', 'OpenSearch', 'GraphQL', 'PostgreSQL', 'Docker', 'Kubernetes', 'SAFe', '508/ADA', 'GitHub Copilot'];

const LeftPane = () => (
  <div style={styles.left}>
    {/* decorative circles */}
    <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '220px', height: '220px', borderRadius: '50%', background: '#1a1a1a', pointerEvents: 'none' }} />
    <div style={{ position: 'absolute', bottom: '40px', left: '-40px', width: '140px', height: '140px', borderRadius: '50%', background: '#161616', pointerEvents: 'none' }} />

    <div style={styles.statusDot}>
      <span style={styles.dot} />
      Open to opportunities
    </div>

    <div style={{ marginBottom: '1.5rem' }}>
      <div style={styles.name}>Brian<br />Huhn</div>
      <div style={styles.titleText}>Senior Staff Software Engineer</div>
    </div>

    <div style={styles.divider} />

    <p style={styles.bio}>
      Full-stack engineer with 6+ years delivering{' '}
      <strong style={styles.bioStrong}>scalable, accessible systems</strong> in regulated environments. Currently owning full-stack architecture end-to-end on VA federal infrastructure at{' '}
      <strong style={styles.bioStrong}>MTSI</strong>.
    </p>

    <div style={styles.skillsLabel}>Stack</div>
    <div style={styles.skills}>
      {skillsList.map(s => <span key={s} style={styles.skillTag}>{s}</span>)}
    </div>

    <div style={styles.contactLinks}>
      <a href="mailto:huhnbrian@gmail.com" style={styles.contactLink}>
        <span>→</span> huhnbrian@gmail.com
      </a>
      <a href="https://github.com/huhnbp" target="_blank" rel="noopener noreferrer" style={styles.contactLink}>
        <span>→</span> github.com/huhnbp
      </a>
      <a href="https://www.linkedin.com/in/huhnbrian/" target="_blank" rel="noopener noreferrer" style={styles.contactLink}>
        <span>→</span> linkedin.com/in/huhnbrian
      </a>
      <span style={{ ...styles.contactLink, cursor: 'default' }}>
        <span>→</span> Open to relocation: NYC · SF · LA
      </span>
    </div>
  </div>
);

export default LeftPane;